import { getDownloadCommandItem } from './getCommandBarItems';
import { getExtensionFromFileName } from 'owa-file';
import { SxSViewState } from 'owa-sxsdata';
import { SxSCustomData } from './combineCustomData';
import { FilterableMenuItem } from 'owa-filterable-menu';

export function getErrorCommandItems(
    viewState: SxSViewState,
    getExtraCustomDataForDatapoint?: () => SxSCustomData,
    getItemIdForLogging?: null | (() => string),
    getDownloadUrl?: () => string,
    getContainerElementForDownload?: () => HTMLElement
): FilterableMenuItem[] {
    const commandItems: FilterableMenuItem[] = [];

    if (viewState.previewPane?.fileName && isPdf(viewState.previewPane.fileName)) {
        // Currently we are supporting download command in case of
        // error for PDF
        commandItems.push(
            getDownloadCommandItem(
                viewState,
                getExtraCustomDataForDatapoint,
                getDownloadUrl,
                getContainerElementForDownload,
                getItemIdForLogging
            )
        );
    }

    return commandItems.filter(item => !item.disabled);
}

function isPdf(fileName: string): boolean {
    const fileExtension = getExtensionFromFileName(fileName);
    return fileExtension && fileExtension.toLowerCase() === '.pdf';
}
